import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const AssignPlanningTaskDialogTourConfig: AgTechTourConfig = {
    id: 'assign-planning-task-dialog-tour',
    name: 'Assign Task Tour',
    steps: [
        {
            targetId: 'assign-task-user',
            title: 'Assign To',
            description: 'Choose the team member responsible for this task. The task will appear in their My Tasks list.',
            position: 'bottom',
        },
    ]
}
